import React from "react";
import Fimg from "./Nlogo.jpeg";

export const Footer = () => {
  return (
    <div>
      <div className="mainfooter">
        <div className="rightside">
        </div>
        <div className="fotterimage">
          <p>
            All Rights Reserved by Mehr Noshki.{" "}
            <img src={Fimg} alt="" height={"30px"} />
          </p>
        </div>
      </div>
    </div>
  );
};
